<template>
  <div
    :class="{
      'flex flex-col': true,
    }"
  >
    <div ref="homepage-header">
      <PortableText
        v-if="content?.homePagePortableText"
        :portable-data="content?.homePagePortableText || []"
        :class="{
          'text-wrapper rounded': true,
        }"
      />
    </div>
    <div
      :class="{
        'form-container pt-6': true,
      }"
    >
      <SectionBuilderForm
        v-if="sectionBuilderForm"
        v-bind="sectionBuilderForm"
      />
      <PortableText
        v-if="description?.homePagePortableText"
        :portable-data="description?.homePagePortableText || []"
        :class="{
          'form-description font-ptc-Rajdhani text-base md:text-21px md:leading-8': true,
        }"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import SectionBuilderForm from '~/components/Atmos/Form/SectionBuilderForm.vue';
import type { HomepageHeader } from '~/sanity/types';

defineProps<HomepageHeader>();
</script>

<style>
.form-description h5 {
  line-height: 2rem !important;
}
</style>
